import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN;
let isInitialized = false;

export function initMixpanel() {
  if (!MIXPANEL_TOKEN || isInitialized || typeof window === "undefined") return;
  mixpanel.init(MIXPANEL_TOKEN, {
    debug: process.env.NODE_ENV === "development",
    track_pageview: false, // handled manually
    persistence: "localStorage",
  });
  isInitialized = true;
}

export interface MixpanelUser {
  _id: string;
  firstName: string;
  lastName?: string;
  email: string;
  imgUrl?: string;
  onboardingCompleted?: boolean;
  activeStatus?: string;
}

export function identifyUser(user: MixpanelUser) {
  initMixpanel();
  if (!isInitialized) return;
  mixpanel.identify(user._id);
  mixpanel.people.set({
    $name: `${user.firstName} ${user.lastName || ""}`.trim(),
    $first_name: user.firstName,
    $last_name: user.lastName || "",
    $email: user.email,
    ...(user.imgUrl && { $avatar: user.imgUrl }),
    onboarding_completed: user.onboardingCompleted ?? false,
    active_status: user.activeStatus || "active",
  });
}

export function trackEvent(
  event: string,
  properties?: Record<string, unknown>
) {
  initMixpanel();
  if (!isInitialized) return;
  mixpanel.track(event, properties);
}

export function trackPageView(pathname: string) {
  initMixpanel();
  if (!isInitialized) return;
  mixpanel.track("Page Viewed", { page: pathname });
}

export function resetMixpanel() {
  initMixpanel();
  if (!isInitialized) return;
  mixpanel.reset();
}
